var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-instructions-eligibility page-instructions" },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "page-content" },
        [
          _vm.$store.state.isAMCSite
            ? [
                _c("h2", { staticClass: "h2 color-gray-1" }, [
                  _vm._v("2026年哈佛HSYLC峰会现招募“少年挚愿者”")
                ]),
                _c("p", { staticClass: "text1 color-gray-2 mt-30" }, [
                  _vm._v(
                    " 峰会招募优秀高中生以“少年挚愿者”身份积极参与和服务峰会的公益行动，该学生通过峰会前期在组委会带领下参与服务峰会中偏远和贫困地区学生适应峰会预习材料等帮扶工作，为国际青年交流盛会贡献力量，进一步展现学生的社会责任和公益行为。该“少年挚愿者”需经过严格选拔，选拔标准包括学术能力、参与文化交流的主动性以及参与公益服务的意愿等。 "
                  )
                ]),
                _c("p", { staticClass: "text1 color-gray-2 mt-10" }, [
                  _vm._v(
                    "为成为哈佛HSYLC峰会的“少年挚愿者”，申请者必须满足以下所有条件："
                  )
                ])
              ]
            : _c("p", { staticClass: "text1 color-gray-2" }, [
                _vm._v("为参与HSYLC，申请者必须满足以下"),
                _c("span", { staticClass: "sybold" }, [_vm._v("所有条件")]),
                _vm._v(":")
              ]),
          _c("h2", { staticClass: "h2 color-gray-1 mt-30" }, [_vm._v("年级")]),
          _vm._m(1),
          _c("h2", { staticClass: "h2 color-gray-1 mt-30" }, [_vm._v("国籍")]),
          _c("p", { staticClass: "text1 color-gray-2 mt-10" }, [
            _vm._v("国籍不限，无论在中国高中还是海外高中就读的学生都可以参加。")
          ]),
          _c("h2", { staticClass: "h2 color-gray-1 mt-30" }, [
            _vm._v("语言水平")
          ]),
          _vm._m(2),
          !_vm.$store.state.isAMCSite
            ? [
                _c("h2", { staticClass: "wrap-title sybold" }, [
                  _vm._v("学生实习生（Student Intern）")
                ]),
                _c("p", { staticClass: "text1 color-gray-2 mt-10" }, [
                  _vm._v(
                    " 欢迎加入每年数百位再次回归峰会的学生行列！每年的内容、学者、和校友都不同，在这里你将获得新的惊喜和成长，同时我们也非常鼓励往年学生申请峰会现场的进阶角色——学生实习生(Student Intern, 初三到高三学生皆可申请)，经选拔录取后，可加入幕后策划和执行工作，承担更多责任，获得更大历练，进一步强化自己的领导能力和团队协作能力，获得实习证明。 "
                  )
                ]),
                _c(
                  "p",
                  {
                    staticClass:
                      "text1 text-1 bold color-red-default mt-10 pointer underline",
                    on: {
                      click: function($event) {
                        return _vm.$windowOpen(
                          "https://mp.weixin.qq.com/s/e7efFmXXRPMzZmsJwKx9Ag"
                        )
                      }
                    }
                  },
                  [_vm._v("点击了解峰会学生实习生")]
                ),
                _c("h2", { staticClass: "h2 color-gray-1 mt-30" }, [
                  _vm._v("HSYLC大学生志愿者")
                ]),
                _c("p", { staticClass: "text1 color-gray-2 mt-20" }, [
                  _vm._v(
                    " 如果你是往年峰会学生，并且已经升入大学学习，欢迎你作为HSYLC大学生志愿者回归峰会（截止2026年9月，大学生志愿者申请人必须完成大学一年级的学习），以“助教辅导员（TF）”、“活动管培生（EA）”、“全媒体助理（MA）”的不同身份深入体验峰会的幕后工作，短时间内快速掌握硬核职场技能，在高能跨国团队协作中激发自己的领导力。HSYLC 2026 志愿者申请预计将在3月下旬开放。 "
                  )
                ]),
                _c(
                  "p",
                  {
                    staticClass:
                      "text1 text-1 color-red-default underline mt-10 bold pointer",
                    on: {
                      click: function($event) {
                        return _vm.$windowOpen("/join-us/volunteer")
                      }
                    }
                  },
                  [_vm._v(" 点击了解峰会大学生志愿者项目详情 ")]
                ),
                _c(
                  "div",
                  { staticClass: "link-wrap" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "link-more next sybold",
                        attrs: { to: "/instructions/dates" }
                      },
                      [
                        _vm._v(" 活动及申请时间 "),
                        _c("Arrow", {
                          attrs: { color: "#17181A", width: "14px" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "banner-wrap" }, [
      _c("h1", { staticClass: "banner-title bold" }, [_vm._v("申请资格")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "text1 color-gray-2 mt-10" }, [
      _vm._v(
        " 现就读初三至高三同学，因此作为申请者，截至2026年9月，你必须已经完成初中学业，且还未开始就读大学。"
      ),
      _c("br"),
      _vm._v(
        " 若你正处于高中毕业后的间隔年(Gap Year），还未开始大学学业，可作为学生申请HSYLC。 "
      )
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "ul text1 color-gray-2 mt-10" }, [
      _c("li", [
        _vm._v(
          "由于在课堂上需要用英语与师生互动讨论，HSYLC要求所有学生具备良好的中英文阅读、沟通和书写能力。"
        )
      ]),
      _c("li", [
        _vm._v(
          " 托福或雅思等标准化考试成绩在申请中不是必须的，没有相关考试成绩的同学将不会影响被录取几率，可通过申请表中的在校成绩、英文文书等体现自己的语言能力。 "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }